export default __webpack_public_path__ + "static/media/Snd_s1.2aefc290.mp3";